/**
 * Application Entry Point
 *
 * Keep this file minimal - just mounts the App component.
 */

// Must be the first import: disables console logging outside APP_ENV=development.
import '@/shared/utils/consoleLoggingGate';

// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { enableMapSet } from 'immer';

import { App } from '@/app/App';

// Required for Zustand+Immer stores that use Set/Map (e.g. row selection Sets).
enableMapSet();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  // <StrictMode>
  <App />
  // </StrictMode>
);
